import _ from "lodash";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import session from "redux-persist/lib/storage/session";
import {
  getEventDetailsBroker,
  getEventDetailsBrokerClear,
  getEventDetailsNIIT,
  getEventDetailsNIITClear,
  getSessionNIITList,
  getSessionNIITListClear,
  getSessionBrokerList,
  getSessionBrokerListClear,
  getEnrollBrokerSession,
  getEnrollBrokerSessionClear,
  joinSession,
  joinSessionClear,
  setEnrollBrokerSessionResponse,
  eventNotification,
  checkEventNotification,
  eventNotificationClear,
  checkEventNotificationClear,
  cancelSessionData,
  cancelSessionDataClear,
  hostSessionClear,
  hostSession,
  sessionWatchURLDataClear,
  sessionWatchURLDataResponse,
  boardcastDataResponse,
  getCalendarSessionList,
  getEnrollAvailabilityClear,
  getEnrollAvailability,
} from "../../redux/events/actions";
import { clickStreamUser, SessionKeys, timezoneArea, timezoneTagName } from "../../utils/AppUtils";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { cartPageDataResponse } from "../../redux/checkout/actions";
import { color, style } from "@mui/system";
import {
  fetchTimezoneAbbr,
  fetchTimezoneAbbrClear,
} from "../../redux/user/actions";
import { addToCart, addToCartClear } from "../../redux/product/actions";
import Loader from "../Loader/Loader";
import AssignCourseModal from "../modal/AssignCourseModal";
import { setCurrentView } from "../../redux/assignCourse/actions";
import ConfirmModal from "../modal/ConfirmModal";
import { Tab, Tabs } from "react-bootstrap";

const EventDetailSection = ({ setIsLoading }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const event_id = params.get("event_id");
  const event_code = params.get("event_code");
  const source = params.get("source");
  // const providerId = params.get("providerId");

  const sessionListRes = useSelector((state) => state.events.sessionList);
  const sessionBrokerListRes = useSelector(
    (state) => state.events.sessionListBroker
  );
  const eventDetailRes = useSelector((state) => state.events.eventDetail);
  const eventDetailResBroker = useSelector(
    (state) => state.events.eventDetailBroker
  );
  const enrollAvailability = useSelector(
    (state) => state.events.enrollAvailability
  );
  const enrollBrokerSession = useSelector(
    (state) => state.events.enrollBrokerSession
  );
  const addToCartRes = useSelector((state) => state.product.addToCart);
  const notfiyEnrolled = useSelector((state) => state.events.eventNotification);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const joinSessionData = useSelector((state) => state.events.joinSession);
  const checkNotified = useSelector((state) => state.events.checkNotified);
  const sessionCancelledData = useSelector(
    (state) => state.events.sessionCancel
  );
  const hostSessionInfo = useSelector((state) => state.events.hostSession);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const timezoneAbbr = useSelector((state) => state.user.timezoneAbbr);
  const userRole = useSelector((state) => state.user.role);
  const currentView = useSelector((state) => state.assignCourse.current_view);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const [isSessionDataLoaded, setIsSessionDataLoaded] = useState(false);
  const [sessionList, setSessionList] = useState([]);
  const [pastSessionList, setPastSessionList] = useState([]);
  const [eventDetail, setEventDetail] = useState({});
  const [open, setOpen] = useState([]);
  const [infoModal, setInfoModal] = useState(false);
  const [showInfoModalMsg, setShowInfoModalMsg] = useState("");
  const [notifyMeBtn, setNotifyMeBtn] = useState(false);
  const [show, setShow] = useState(false);
  const [isNotified, setIsNotified] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [zoneAbbr, setZoneAbbr] = useState("CDT");
  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedSession, setSelectedSession] = useState('')

  const [confirmModal, setConfirmModal] = useState(false)
  const [showModalMsg,] = useState('Would you like to unregister from the session?')
  const [sessionDataForModal, setSessionDataForModal] = useState({})
  const [viaRegisterRoute, setViaRegisterRoute] = useState(false)
  const [currentWeekStart, setCurrentWeekStart] = useState(moment().startOf("week"))
  const [pastClicked, setPastClicked] = useState(false);
  // console.log("Session dataaaaa", sessionList[2]?.source);

  useEffect(() => { dispatch(setCurrentView(1)) }, [])

  useEffect(() => {
    if (params.get("register")) {
      setViaRegisterRoute(true)
    }
  }, [params])

  useEffect(() => {
    // console.log("userDetailRes: ", userDetailRes);
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      setUserDetails(userDetailRes?.payload?.payload);
      // dispatch(
      //   fetchTimezoneAbbr({
      //     module: "fetchTimezoneAbbr",
      //     postData: {
      //       offset: userDetailRes.payload.payload.timezone,
      //     },
      //   })
      // );
    }
  }, [userDetailRes]);

  useEffect(() => {
    if (!_.isEmpty(timezoneAbbr)) {
      if (timezoneAbbr.status === "success") {
        // console.log("timezoneAbbr", timezoneAbbr);
        // const timezoneAbbrData = timezoneAbbr.payload?.payload;
        // if (!_.isEmpty(timezoneAbbrData)) {
        //   const abbr = timezoneAbbrData.abbr[0].abbreviations;
        //   setZoneAbbr(abbr);
        // }
      }
      dispatch(fetchTimezoneAbbrClear());
    }
  }, [timezoneAbbr]);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      clickStreamUser("event-detail-page", {
        eventId: event_id,
        user_id: authBroker?.payload?.user?.user_id,
      });
    }
  }, [authBroker]);

  useEffect(() => {
    if (selectedSession !== '') {
      setShow(true)
    }
  }, [selectedSession])

  useEffect(() => {
    // console.log("joinSessionData", joinSessionData);
    if (!_.isEmpty(joinSessionData)) {
      setIsLoading(false);
      if (joinSessionData.status === "success") {
        if (!_.isEmpty(joinSessionData.payload.payload)) {
          const sessionData = joinSessionData.payload.payload;
          if (sessionData.join_url) {
            window.open(sessionData.join_url, "_blank");
          } else {
            // window.scrollTo(0, 0);
            setShowInfoModalMsg("Error joining session, please contact support");
            // setInfoModal(true);
          }
        }
      } else {
        // console.log(joinSessionData.error.message);
        // setShowInfoModalMsg(joinSessionData.error.message);
        let msg = joinSessionData.error.message
        setShowInfoModalMsg(msg ? msg : "Error joining session, please contact support");
      }
      window.scrollTo(0, 0);
      setInfoModal(true);
      setTimeout(() => {
        setInfoModal(false)
        setShowInfoModalMsg('')
      }, 5000)
      dispatch(joinSessionClear());
    }
  }, [joinSessionData]);

  useEffect(() => {
    // setShowInfoModalMsg(addToCartRes?.payload.message)
    if (Object.keys(addToCartRes).length !== 0) {
      // navigate("/cart");
      // dispatch(addToCartClear());
    }
  }, [addToCartRes]);

  //SESSIONS INFO
  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (source === "broker" && !_.isEmpty(authBroker)) {
        dispatch(
          getEventDetailsBroker({
            module: "eventDetailBroker",
            postData: {
              event_id: event_id,
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              language: activeLanguage ? activeLanguage : ""
            },
          })
        );
        // console.log("called");
        dispatch(
          getSessionBrokerList({
            module: "sessionBrokerList",
            postData: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              event_id: event_id,
              broker_id: authBroker?.payload?.user?.broker_id,
              language: activeLanguage ? activeLanguage : ""
              // providerId: providerId ? providerId : ''
            },
          })
        );
      } else {
        dispatch(
          getSessionNIITList({
            module: "sessionList",
            postData: {
              email: authBroker.payload.user.email,
              event_id: event_id,
              user_id: authBroker?.payload?.user?.user_id,
              company_id: authBroker?.payload?.user.company_id,
              // providerId: providerId ? providerId : ''
            },
          })
        );

        dispatch(
          getEventDetailsNIIT({
            module: "GetEvent",
            postData: {
              module: "GetEvent",
              // event_code: event_code,
              eventcode: event_code,
              // providerId: providerId ? providerId : ''
            },
          })
        );
      }
      dispatch(
        checkEventNotification({
          module: "check-notified",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            event_id: event_id,
            origin: source === "broker" ? "broker" : "xsel",
          },
        })
      );
      dispatch(sessionWatchURLDataClear());
    }
  }, [dispatch, authBroker, source]);

  useEffect(() => {

    if (!_.isEmpty(sessionListRes)) {
      setIsLoading(false);
      if (sessionListRes?.status === "success") {
        if (!_.isEmpty(sessionListRes.payload.payload)) {
          let sessionList = _.clone(sessionListRes.payload.payload.sessionList);
          if (_.isArray(sessionList)) {
            let newSessionList = [];
            let pastSessionList = [];
            for (let sessionData of sessionList) {
              let session = _.cloneDeep(sessionData);
              session.source = 'xsel';
              let api_date_format = "YYYY-MM-DD HH:mm";
              const timezoneOffset = sessionData.timezone.includes(":") ? sessionData.timezone.replace(":", "") : "-0400";
              const area = timezoneArea(timezoneOffset);
              const currentTime = moment().tz(area);
              session.startDate = moment(session.startDate).format(
                "MMM DD, YYYY"
              );
              session.startTime = moment(session.startTime).format("HH") * 100;
              if (session.startTime < 1000) {
                session.startTime = "0" + session.startTime;
              }
              session.can_enroll = false;
              session.hostZoomId = authBroker.payload.user.zoom_id;
              session.userId = authBroker?.payload?.user?.user_id;
              session.host = session.display_name;
              session.show_join = false;
              session.isOffer = false;
              session.originalPrice = session.selling_price;
              session.is_broadcast = session.delivery_mode === 'virtual_broadcast'

              if (isPremiumUser) {
                if (
                  session.sfdc_product_type.toLowerCase() === "basic" ||
                  session.sfdc_product_type.toLowerCase() === "premium"
                ) {
                  session.can_enroll = true;
                }
                if (session.offer_available) {
                  session.isOffer = true;
                  session.originalPrice = session.product_premium_price
                }
              } else {
                session.can_enroll =
                  session.sfdc_product_type.toLowerCase() === "basic";
                if (session.offer_available) {
                  session.isOffer = true;
                  session.originalPrice = session.product_basic_price
                }
              }

              if (session.register) {
                session.is_paid = true;
              }

              let notPastFlag = false;
              let isFuture = true;
              let firstSegmentStartDateTime = moment()
              let firstSegmentEndDateTime = moment()
              session.start_url = "";
              session.join_url = "";
              session.meeting_id = "";
              session.segmentId = "";
              if (_.isArray(session.date_time) &&
                !_.isEmpty(session.date_time)) {
                for (let record of session.date_time) {
                  const userTz = moment.tz.guess();

                  session.watch_url = record.watch_url;
                  record.startUTC = record?.start_date?.replaceAll("-", "/") +
                    " " +
                    record.start_time;
                  record.startDateTime = moment
                    .utc(
                      record?.start_date?.replaceAll("-", "/") +
                      " " +
                      record.start_time
                    )
                    .tz(area)
                  record.endDateTime = moment
                    .utc(
                      record?.end_date?.replaceAll("-", "/") +
                      " " +
                      record.end_time
                    )
                    .tz(area)
                  record.timezone = record?.startDateTime?.format('z'); 
                  record.startD = record?.startDateTime?.format("DD MMM YYYY");
                  record.endD = record?.endDateTime?.format("DD MMM YYYY");
                  
                  if (!session.show_join) {

                    let can_join = session.is_registered ?
                    session.show_join
                        ? session.show_join
                        : currentTime?.isBetween(
                            moment(record.startDateTime).subtract(1, 'hour'),
                            record.endDateTime
                        ) : false;
                    session.show_join = can_join
                    if (can_join) {
                        session.segmentId = record.segment_id;
                        session.start_url = record.start_url ? record.start_url : "";
                        session.join_url = session.delivery_mode === "face_to_face" ? (record.inperson_meeting_url ? record.inperson_meeting_url : "") : record.join_url ? record.join_url : "";
                        session.meeting_id = record.meeting_id;
                    }
                  }
                  record.is_past = currentTime?.isAfter(record.endDateTime);

                  session.currentTime = currentTime?.format(api_date_format);
                  session.is_host = record.is_host;
                  session.is_participant = record.is_participant;
                  
                  session.start = moment(
                    record.startDateTime.format(api_date_format)
                  ).toDate();
                  session.end = moment(
                    record.endDateTime.format(api_date_format)
                  ).toDate();
                  // session.start_url = record.start_url ? record.start_url : "";
                  // session.join_url = record.join_url ? record.join_url : "";
                  session.durationValue = _.toInteger(
                    moment
                      .duration(record.endDateTime.diff(record.startDateTime))
                      .asMinutes()
                  );
                  session.duration =
                    _.toInteger(
                      moment
                        .duration(record.endDateTime.diff(record.startDateTime))
                        .asMinutes()
                    ) + "mins";

                  if (!record.is_past) {
                    notPastFlag = true;
                  } else {
                    isFuture = false;
                  }

                }
                session.date_time = _.sortBy(session.date_time, 'startDateTime')
                firstSegmentStartDateTime = session.date_time[0].startDateTime
                firstSegmentEndDateTime = session.date_time[0].endDateTime
                for (let record of session.date_time) {
                  if (_.toNumber(session.selling_price) !== 0 &&
                    currentTime.isAfter(firstSegmentStartDateTime.clone().add(30, 'minutes'))
                    && !session.is_registered) {
                    record.is_past = true;
                    notPastFlag = false;
                    isFuture = false;
                  }
                }
              }
              let cross_30Timer = firstSegmentStartDateTime.clone().add(30, 'minutes')
              session.cross_30Timer = cross_30Timer.format('DD/MM/YYYY hh:mm:ss a z')
              session.first_segment_date_time = firstSegmentStartDateTime;
              session.cross_30 = currentTime.isSameOrAfter(cross_30Timer);
              session.first_segment_end = currentTime.isSameOrBefore(firstSegmentEndDateTime)
              session.show_register = firstSegmentStartDateTime.isSameOrAfter(currentTime)
              session.is_past = !notPastFlag
              session.isFuture = isFuture;
              if (viaRegisterRoute) {
                if (session.is_registered) {
                  newSessionList.push(session)
                  pastSessionList.push(session)
                }
              } else {
                console.log("Session Data", session);
                if (!session.is_past) {
                  if (!_.isEmpty(session.date_time)) {
                    newSessionList.push(session);
                    pastSessionList.push(session)
                  }
                } else if (session.is_past && session.is_registered) {
                  if (!_.isEmpty(session.date_time)) {
                    newSessionList.push(session);
                  }
                  pastSessionList.push(session)
                } else {
                  pastSessionList.push(session)
                }
              }
            }

            console.log("past Session List", getFilteredSessionList(pastSessionList, true));
            console.log("upcoming Session List", getFilteredSessionList(newSessionList, false))
            setSessionList(getFilteredSessionList(newSessionList, false));
            setPastSessionList(getFilteredSessionList(pastSessionList, true))
            setIsSessionDataLoaded(true);
          } else {
            setSessionList([]);
            setPastSessionList([])
            setIsSessionDataLoaded(true);
          }
        }
      } else {
        setIsSessionDataLoaded(true);
        setSessionList([]);
        setPastSessionList([])
      }
      dispatch(getSessionNIITListClear());
    }
  }, [sessionListRes]);

  useEffect(() => {
    // console.log("sessionListRes: data", sessionBrokerListRes);
    if (!_.isEmpty(sessionBrokerListRes)) {
      setIsLoading(false);
      if (sessionBrokerListRes.status === "success") {
        if (!_.isEmpty(sessionBrokerListRes.payload.payload)) {
          let sessionList = sessionBrokerListRes.payload.payload.sessionList;
          // console.log("allEvents1: ", sessionList);
          let newSessionList = [];
          let pastSessionList = [];
          if (_.isArray(sessionList)) {
            for (let session of sessionList) {
              let api_date_format = "YYYY-MM-DD HH:mm";
              session.source = 'broker';
              // const timezoneOffset = !_.isEmpty(userDetails.timezone)
              //   ? userDetails.timezone.replace(":", "")
              //   : "-0500";
              // const timezoneOffset = session.timezone.replace(":", "");
              const timezoneOffset = session.timezone.includes(":") ? session.timezone.replace(":", "") : "-0400";
              // const area = session.timezoneAbbr ? session.timezoneAbbr : 'America/New_York'; //timezoneArea(timezoneOffset);
              const area = timezoneArea(timezoneOffset);
              const currentTime = moment().tz(area);
              // console.log("OFFSET", timezoneOffset);
              session.startDate = moment(session.startDate).format(
                "MMM DD, YYYY"
              );
              session.startTime = moment(session.startTime).format("HH") * 100;
              session.can_enroll = true;
              session.hostZoomId = authBroker.payload.user.zoom_id;
              session.userId = authBroker?.payload?.user?.user_id;
              session.host = session.display_name;
              session.show_join = false;
              session.is_broadcast = session.delivery_mode === 'virtual_broadcast'
              // session.date_time_array = _.clone(session.date_time);
              // session.date_time = [];
              let notPastFlag = false;
              let isFuture = true;
              let firstSegmentStartDateTime = moment();
              let firstSegmentEndDateTime = moment();
              session.start_url = "";
              session.join_url = "";
              session.meeting_id = "";
              session.segmentId = "";
              if (_.isArray(session.date_time) &&
                !_.isEmpty(session.date_time)) {
                for (let record of session.date_time) {
                  if (record.start_date) {
                    record.startDateTime = moment
                      .utc(
                        record?.start_date?.replaceAll("-", "/") +
                        " " +
                        record.start_time,

                        "MM-DD-YYYY HH:mm"
                      )
                      .tz(area)
                    record.endDateTime = moment
                      .utc(
                        record?.end_date?.replaceAll("-", "/") +
                        " " +
                        record.end_time,
                        "MM-DD-YYYY HH:mm"
                      )
                      .tz(area)
                    record.startD = record.startDateTime.format("DD MMM YYYY");
                    record.endD = record.endDateTime.format("DD MMM YYYY");
                    record.timezone = record.startDateTime.format('z'); //timezoneTagName(session.timezoneAbbr); //moment.utc().utcOffset(timezoneOffset).format("ZZ");
                    if (!session.show_join) {

                      let can_join = session.is_registered ?
                      session.show_join
                          ? session.show_join
                          : currentTime?.isBetween(
                              moment(record.startDateTime).subtract(1, 'hour'),
                              record.endDateTime
                          ) : false;
                      session.show_join = can_join
                      if (can_join) {
                          session.segmentId = record.segment_id;
                          session.start_url = record.start_url ? record.start_url : "";
                          session.join_url = session.delivery_mode === "face_to_face" ? (record.inperson_meeting_url ? record.inperson_meeting_url : "") : record.join_url ? record.join_url : "";
                          session.meeting_id = record.meeting_id;
                      }
                    }
                    session.is_host = record.is_host;
                    session.is_participant = record.is_participant;
                    session.currentTime = currentTime?.format(api_date_format);
                    session.start = moment(
                      record.startDateTime.format(api_date_format)
                    ).toDate();
                    session.end = moment(
                      record.endDateTime.format(api_date_format)
                    ).toDate();
                    session.durationValue = _.toInteger(
                      moment
                        .duration(record.endDateTime.diff(record.startDateTime))
                        .asMinutes()
                    );
                    session.duration =
                      _.toInteger(
                        moment
                          .duration(record.endDateTime.diff(record.startDateTime))
                          .asMinutes()
                      ) + "mins";
                    record.is_past = currentTime?.isAfter(record.endDateTime);
                    if (!record.is_past) {
                      notPastFlag = true;
                    } else {
                      isFuture = false;
                    }

                  }
                }
                // console.log(session)
                session.date_time = _.sortBy(session.date_time, 'startDateTime')
                firstSegmentStartDateTime = session.date_time[0].startDateTime
                firstSegmentEndDateTime = session.date_time[0].endDateTime
              }
              session.cross_30 = currentTime.isSameOrBefore(firstSegmentStartDateTime.clone().add(30, 'minutes'))
              session.show_register = firstSegmentStartDateTime?.isSameOrAfter(currentTime)
              session.first_segment_end = currentTime.isSameOrBefore(firstSegmentEndDateTime)
              // console.log(session, notPastFlag)
              session.is_past = !notPastFlag
              session.isFuture = isFuture;
              if (viaRegisterRoute) {
                if (session.is_registered) {
                  newSessionList.push(session)
                  pastSessionList.push(session)
                }
              } else {
                if (!session.is_past) {
                  // console.log("Session Data", session);
                  newSessionList.push(session);
                  pastSessionList.push(session)
                } else if (session.is_past && session.is_registered) {
                  newSessionList.push(session);
                  pastSessionList.push(session)
                } else {
                  pastSessionList.push(session)
                }
              }
            }
            console.log("new Session List", getFilteredSessionList(newSessionList, false));
            console.log("past Session List1", getFilteredSessionList(pastSessionList, true));
            setIsSessionDataLoaded(true);
            setSessionList(getFilteredSessionList(newSessionList, false));
            setPastSessionList(getFilteredSessionList(pastSessionList, true));
          } else {
            setIsSessionDataLoaded(true);
            setSessionList([]);
            setPastSessionList([]);
          }
        }
      } else {
        setIsSessionDataLoaded(true);
        setSessionList([]);
        setPastSessionList([]);
      }
      dispatch(getSessionBrokerListClear());
    }
  }, [sessionBrokerListRes]);

  const getFilteredSessionList = (sessionList, isPastTab) => {
    let tempArray = [];
    for (let index = 0; index < sessionList.length; index++) {
      const element = sessionList[index];

      if (!element.isFuture && isPastTab) {
        tempArray.push(element)
      }

      if (!isPastTab && (!(element.is_past))) {
        let isFreeSession = element.can_enroll;
        let cross30 = element.cross_30
        let isRegistered = element.is_registered;

        // if (element.source === 'xsel' && 
        //   (element.is_registered ||
        //   (!element.cross_30
        //   && !element.is_registered))) {
        //       tempArray.push(element)
        //   } else {
        //       console.log('ELIMINATE', element)
        //   }
          
          if (element.source === 'xsel') {
              if (isRegistered) {
                  tempArray.push(element)
              } else if (isFreeSession) {
                  tempArray.push(element)
              } else if (!isFreeSession && !cross30) {
                  tempArray.push(element)
              } else {
                  console.log('ELIMINATE ELSE', element)
              }
          } else if (element.source === 'broker') {
            tempArray.push(element)
          } else {
            console.log('ELIMINATE', element)
          }
      }
    }
    return tempArray
  }

  useEffect(() => {
    if (!_.isEmpty(eventDetailRes) && eventDetailRes?.status === "success") {
      // console.log('allEvents1: ', eventDetailRes)
      let eventDetail = eventDetailRes.payload.payload;
      if (!_.isEmpty(eventDetail)) {
        setEventDetail(eventDetail);
      }
      dispatch(getEventDetailsNIITClear());
    }
  }, [eventDetailRes]);

  useEffect(() => {
    if (
      !_.isEmpty(eventDetailResBroker) &&
      eventDetailResBroker?.status === "success"
    ) {
      // console.log("allEvents1: ", eventDetailResBroker);
      setEventDetail(eventDetailResBroker?.payload.payload);

      dispatch(getEventDetailsBrokerClear());
    }
  }, [eventDetailResBroker]);

  const dispatchAPICall = () => {
    let weekInput = currentWeekStart.clone();
    let date_range = {
      start_date: weekInput.startOf('week').format("MM/DD/YYYY"),
      end_date: weekInput.clone().endOf('week').format("MM/DD/YYYY")
    }
    // console.log('FETCH DATA', date_range)
    dispatch(getCalendarSessionList({
        module: 'calendarSessionListEcom',
        postData: {
          token:localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          date_range,
          language: activeLanguage ? activeLanguage : ""
        }
    }))
  }

  useEffect(() => {
    if (!_.isEmpty(enrollAvailability)) {
      if (enrollAvailability.status === 'success') {
        let data = enrollAvailability.payload.payload;
        if (!_.isEmpty(data)) {
          console.log(data);
          // for(let events of myEvents) {
          //     if (events.source === data.origin && 
          //         events.sessionId === data.session_id) {
          //             navigate(`/shopping/${events.productId}?addToCart=${events.is_addToCart}&source=session`)
          //     }
          // }
          for (let session of sessionList) {
            if (session.source === data.origin &&
              session.session_id === data.session_id) {
              navigate(`/shopping/${session.product_id}?addToCart=${session.is_addToCart}&source=session`)
            }
          }
        }
      } else if (enrollAvailability?.status === "error") {
        setShowInfoModalMsg(enrollAvailability.error.message)
        window.scrollTo(0, 0);
        setInfoModal(true);
        setIsLoading(false)
      }
      setTimeout(() => {
        setInfoModal(false)
        setShowInfoModalMsg('')
      }, 5000)
      dispatch(getEnrollAvailabilityClear())
    }
  }, [enrollAvailability])

  useEffect(() => {
    // console.log("enrolled", enrollBrokerSession);
    if (!_.isEmpty(enrollBrokerSession)) {
      dispatchAPICall();
      if (enrollBrokerSession?.status === "success") {
        if (!_.isEmpty(enrollBrokerSession.payload.payload)) {
          let data = enrollBrokerSession.payload.payload;
          setShowInfoModalMsg(enrollBrokerSession.payload.message);
          window.scrollTo(0, 0);
          // setInfoModal(true);
          clickStreamUser("session-registered-successfull", {
            event_id: event_id,
            session_id: data.session_id,
            user_id: authBroker?.payload?.user?.user_id,
            message: enrollBrokerSession.payload.message,
          });
          fetchSessionList(data);
        } else {
          if (userRole === "realtor" || userRole === "customer") {
            setShowInfoModalMsg(
              "Error registering session, please contact your manager"
            );
          } else if (userRole === "manager") {
            setShowInfoModalMsg(
              "Error registering session, please contact your broker admin"
            );
          } else {
            setShowInfoModalMsg(
              "Error registering session, please contact support"
            );
          }
          // setInfoModal(true);
          setIsLoading(true)
        }
      } else if (enrollBrokerSession?.status === "error") {
        setShowInfoModalMsg(enrollBrokerSession.error.message);
        // window.scrollTo(0, 0);
        setIsLoading(false)
      }
      window.scrollTo(0, 0);
      setInfoModal(true);
      setTimeout(() => {
        setInfoModal(false)
        setShowInfoModalMsg('')
      }, 5000)
      dispatch(getEnrollBrokerSessionClear());
    }
  }, [enrollBrokerSession]);

  useEffect(() => {
    // console.log("Check notified", checkNotified);
    if (checkNotified.status === "success") {
      if (checkNotified.payload.payload.is_notified) {
        setNotifyMeBtn(true);
      }
      dispatch(checkEventNotificationClear());
    }
  }, [checkNotified]);

  useEffect(() => {
    // console.log("NOTIFIED", notfiyEnrolled);
    if (!_.isEmpty(notfiyEnrolled)) {
      if (notfiyEnrolled.status === "success") {
        window.scrollTo(0, 0);
        setShowInfoModalMsg(notfiyEnrolled.payload.message);
        setIsLoaded(false);
      } else {
        window.scrollTo(0, 0);
        setShowInfoModalMsg('Unable to ');
      }
      setInfoModal(true);
      setTimeout(() => {
        setInfoModal(false)
        setShowInfoModalMsg('')
      }, 5000)
      dispatch(eventNotificationClear());
    }
  }, [notfiyEnrolled]);

  useEffect(() => {
    // console.log("sessionCalledData", sessionCancelledData);
    if (!_.isEmpty(sessionCancelledData)) {
      if (sessionCancelledData.status === "success") {
        // setInfoModal(true);
        // fetchSessionList({ origin: source });
        window.scrollTo(0, 0);
        if (source === 'broker') {
          setShowInfoModalMsg('You have successfully unregistered from the session.');
        } else {
          setShowInfoModalMsg("Xsel team will connect with you shortly.");
        }
        let data = {
          origin: source
        }
        fetchSessionList(data)
      } else {
        if (userRole === "realtor" || userRole === "customer") {
          setShowInfoModalMsg(
            "Error cancelling session, please contact your manager."
          );
        } else if (userRole === "manager") {
          setShowInfoModalMsg(
            "Error cancelling session, please contact your broker admin."
          );
        } else {
          setShowInfoModalMsg(
            "Error cancelling session, please contact support."
          );
        }
        window.scrollTo(0, 0);
      }
      setInfoModal(true);
      setIsLoading(false);
      setTimeout(() => {
        setInfoModal(false)
        setShowInfoModalMsg('')
      }, 5000)
      dispatch(cancelSessionDataClear());
    }
  }, [sessionCancelledData]);

  useEffect(() => {
    if (!_.isEmpty(hostSessionInfo)) {
      setIsLoading(false);
      if (hostSessionInfo.status === "success") {
        if (!_.isEmpty(hostSessionInfo.payload.payload)) {
          // console.log("hostSessionInfo", hostSessionInfo.payload.payload);
          const hostData = hostSessionInfo.payload.payload.data;
          if (hostData.start_url) {
            window.open(hostData.start_url, "_blank");
          } else {
            window.scrollTo(0, 0);
            setShowInfoModalMsg("Server Error, please contact support");
            // setInfoModal(true);
          }
          // dispatch(hostSessionClear());
        } else {
          // console.log(hostSessionInfo.error.message);
          setShowInfoModalMsg(hostSessionInfo.error.message);
          // setInfoModal(true);
        }
      } else {
        setShowInfoModalMsg(hostSessionInfo.error.message);
      }
      window.scrollTo(0, 0);
      setInfoModal(true);
      setTimeout(() => {
        setInfoModal(false)
        setShowInfoModalMsg('')
      }, 5000)
      dispatch(hostSessionClear())
    }
  }, [hostSessionInfo]);

  const fetchSessionList = (data) => {
    if (data.origin === "broker") {
      dispatch(
        getSessionBrokerList({
          module: "sessionBrokerList",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            event_id: event_id,
            broker_id: authBroker?.payload?.user?.broker_id,
            language: activeLanguage ? activeLanguage : ""
          },
        })
      );
    } else {
      dispatch(
        getSessionNIITList({
          module: "sessionList",
          postData: {
            email: authBroker.payload.user.email,
            event_id: event_id,
            user_id: authBroker?.payload?.user?.user_id,
          },
        })
      );
    }
  };

  const setDeliveryMode = (deliveryMode) => {
    switch (deliveryMode) {
      case "virtual_broadcast":
        return "Virtual Broadcast";
      case "virtual_interactive":
        return "Virtual Interactive";
      case "face_to_face":
        return "In-person";
    }
  };

  const proceedToRegister = (session, type) => {
    console.log("session", session);
    clickStreamUser("register-button-clicked", {
      event_id: event_id,
      session_id: session.session_id,
      session_name: session.session_name,
      user_id: authBroker?.payload?.user?.user_id,
      type: source === "broker" ? "broker" : "xsel",
    });
    dispatch(
      getEnrollBrokerSession({
        module: "enrollBrokerSession",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          session_id: session.session_id,
          event_id: event_id,
          type: source === "broker" ? "broker" : "xsel",
          language: activeLanguage ? activeLanguage : ""
        },
      })
    );
    setIsLoading(true);
  };

  const proceedToBook = (session) => {
    // console.log("SESSION", session);
    clickStreamUser("proceed-to-book-session", {
      event_id: event_id,
      session_id: session.session_id,
      session_name: session.session_name,
      user_id: authBroker?.payload?.user?.user_id,
    });
    if (session.delivery_mode === 'virtual_broadcast') {
      navigate(`/shopping/${session.product_id}?addToCart=${session.is_addtocart}&source=session`)
    } else {
      dispatch(getEnrollAvailability({
        module: "checkEnrollAvailability",
        postData: {
          token: session.isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          session_id: session.session_id,
          event_id: session.eventId,
          type: source === "broker" ? "broker" : "xsel",
        }
      }))
    }
    setIsLoading(true);
  };

  const launchSession = (session) => {
    clickStreamUser("launch-session", {
      event_id: event_id,
      session_id: session.session_id,
      session_name: session.session_name,
      user_id: authBroker?.payload?.user?.user_id,
    });
    if (session.is_broadcast) {
      console.log('Session', session)
      dispatch(boardcastDataResponse({
        eventId: event_id,
        sessionId: session.session_id,
        source: session.source
      }))
      navigate('/session/broadcast/watch');
    } else {
      if (session.join_url) {
        window.open(session.join_url, "_blank");
      } else {
        dispatch(
          joinSession({
            module: "joinZoomMeeting",
            postData: {
              user_id: authBroker?.payload?.user?.user_id,
              meeting_id: session.meeting_id,
              session_id: session.session_id,
              segment_id: session.segmentId,
            },
          })
        );
        

      }
    }
  };

  const cancelConfirm = (session) => {
    setSessionDataForModal(session)
    setConfirmModal(true)
  }

  const cancelSession = (session) => {
    // console.log(session)
    setConfirmModal(false)

    clickStreamUser("cancel-session", {
      event_id: event_id,
      session_id: session.session_id,
      session_name: session.session_name,
      user_id: authBroker?.payload?.user?.user_id,
    });
    dispatch(
      cancelSessionData({
        module: "sessionCancel",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          session_id: session.session_id,
          session_title: session.session_name,
          event_id: event_id,
          origin: source === 'broker' ? 'broker' : 'xsel'
        },
      })
    );
    setIsLoading(true);
  };

  const watchSession = (session, watchURL) => {
    clickStreamUser("watch-session-btn-clicked", {
      event_id: event_id,
      session_id: session.session_id,
      session_name: session.session_name,
      user_id: authBroker?.payload?.user?.user_id,
    });
    dispatch(
      sessionWatchURLDataResponse({
        id: session.session_id,
        title: session.session_name,
        watch_url: watchURL,
      })
    );
    navigate("/session/watch");
  };

  const proceedToHost = (session) => {
    
    if (session.is_broadcast) {
      dispatch(boardcastDataResponse({
        eventId: event_id,
        sessionId: session.session_id,
        source: session.source
      }))
      navigate('/session/broadcast/watch');
    } else {
      if (session.start_url) {
        window.open(session.start_url, "_blank");
      } else {
        dispatch(
          hostSession({
            module: "createZoomMeeting",
            postData: {
              user_id: session.userId,
              host_zoom_id: session.hostZoomId,
              meeting_topic: session.session_name,
              meeting_agaenda: session.session_name,
              meeting_startdate: moment.utc(session.startUTC).format("YYYY-MM-DD HH:mm") + ":00",
              duration: _.toNumber(session.durationValue),
              session_id: session.sessionId,
              segment_id: session.segmentId,
            },
          })
        );
        setIsLoading(true);
      }
    }
  };

  const renderRegisterButton = (session, type) => {
    if (session.show_register || session.first_segment_end) {
      return (
        <button
          type="button"
          className="btn btn-primary btn-primaryBook_ED cursor-pointer"
          onClick={() => proceedToRegister(session, type)}
        >
          Register
        </button>
      )
    } else if (session.selling_price !== 0) {
      return (
        <button
          type="button"
          className="btn btn-primary btn-primaryBook_ED cursor-pointer"
          onClick={() => proceedToRegister(session, type)}
        >
          Register
        </button>
      )
    }
  }

  const renderButton = (session, isPastTab) => {
    if (source === "broker") {
      if (session.is_host) {
        if (!session?.is_past) {
          if (session.show_join) {
            return (
              <p className="text-left_ED">
                <button
                  type="button"
                  className={`btn btn-primary btn-primaryBook_ED cursor-pointer`}
                  onClick={() => proceedToHost(session)}
                >
                  Host
                </button>
              </p>
            );
          } else {
            return (
              <p className="text-left_ED">
                <button
                  type="button"
                  className="btn btn-primary btn-primaryBook_ED cursor-pointer event-btn disabled"
                  onClick={() => proceedToHost(session)}
                >
                  Host
                </button>
              </p>
            );
          }
        }
      } else if (!session.is_registered && !session.is_participant) {
        if (session?.is_past) {
          return (<></>)
        } else {
          return (
            <p className="text-left_ED">
              {!isPastTab && renderRegisterButton(session, 'broker')}
            </p>
          );
        }
      } else {
        return <p className="text-left_ED">{!isPastTab && renderJoinButton(session)}</p>;
      }
    } else {
      return (
        <p className="text-left_ED">
          {!session?.is_registered ? (
            <>
              {session?.can_enroll ? (
                session.is_past ? (
                  ""
                ) : (
                  !isPastTab && renderRegisterButton(session, 'xsel')
                )
              ) :
                ((session.show_register ||
                  !session.cross_30)) ?
                  (
                    !isPastTab && <button
                      type="button"
                      className="btn btn-primary btn-primaryBook_ED cursor-pointer"
                      onClick={() => proceedToBook(session)}
                    >
                      {session.is_addtocart ? 'Added in Cart' : 'Book'}
                    </button>
                  )
                  : ""
              }
            </>
          ) : (
            // (!session?.is_paid && !session?.is_registered) ? <>{!isPastTab && renderRegisterButton(session, 'xsel')}</> :
            <>{!isPastTab && renderJoinButton(session)}</>
          )}
        </p>
      );
    }
  };

  const renderJoinButton = (session) => {
    if (session.delivery_mode === "face_to_face") {
      // if (session.show_join) {
      //   return (
      //     <div className="d-flex flex-column gap-2">
      //       <button
      //         type="button"
      //         className="btn btn-primary btn-primaryBook_ED cursor-pointer"
      //         onClick={() => { }}
      //       >
      //         In-person
      //       </button>
      //     </div>
      //   )
      // } else {
      return (
        <div className="d-flex flex-column gap-2">
          {!_.isEmpty(session?.join_url) && <button
            type="button"
            className="btn btn-primary btn-primaryBook_ED cursor-pointer"
            onClick={() => launchSession(session)}
          >
            Join
          </button>}
          {!session.show_join && <button
            type="button"
            className="btn btn-primary btn-primaryBook_ED cursor-pointer event-btn"
            onClick={() => cancelConfirm(session)}
          >
            Cancel
          </button>}
        </div>
      )
      // }
    } else if (session.show_join) {
      return (
        <button
          type="button"
          className="btn btn-primary btn-primaryBook_ED cursor-pointer"
          onClick={() => launchSession(session)}
        >
          Join
        </button>
      );
    } else {
      if (!session.is_past) {
        return (
          <div className="d-flex flex-column gap-2">
            <button
              type="button"
              className="btn btn-primary btn-primaryBook_ED cursor-pointer"
              disabled
              onClick={() => launchSession(session)}
            >
              Join
            </button>
            <button
              type="button"
              className="btn btn-primary btn-primaryBook_ED cursor-pointer event-btn"
              onClick={() => cancelConfirm(session)}
            >
              Cancel
            </button>
          </div>
        );
      } else if (session.watch_url) {
        // return (
        //   <button
        //     type="button"
        //     className="btn btn-primary btn-primaryBook_ED cursor-pointer event-btn"
        //   >
        //     Watch
        //   </button>
        // );
      }
    }
  };

  const renderAlertCard = () => {
    return (
      <div
        className={`alert-card d-flex justify-content-center topsecalert ${infoModal ? "" : "d-none"
          }`}
      >
        <div className="shop-cart order-details event-notify-sucess">
          <div className="shop-info justify-content-center">
            
            <p className="m-0">{showInfoModalMsg}</p>
          </div>
          <div className="view-cart-icon">
           
            <i
              className="fa fa-times cursor-pointer"
              aria-hidden="true"
              onClick={() => {
                setInfoModal(false);
                setShowInfoModalMsg("");
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };

  const onNotifyMeHandler = () => {
    // token: <user-token>,
    // event_id : <event_id>,
    setIsLoaded(true);
    dispatch(
      eventNotification({
        module: "event_Notify_Me",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          event_id: event_id,
          origin: source === "broker" ? "broker" : "xsel",
          status: "checked",
        },
      })
    );
    setNotifyMeBtn(true);

    // window.scrollTo(0, 0);
    // setShow(true);
    // window.scroll({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
    // alert("We will notify you whenever the session is addes to this event");
  };
  //unchecked notify me
  const uncheckNotifyMeHandler = () => {
    // token: <user-token>,
    // event_id : <event_id>,
    setIsLoaded(true);
    dispatch(
      eventNotification({
        module: "event_Notify_Me",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          event_id: event_id,
          origin: source === "broker" ? "broker" : "xsel",
          status: "unchecked",
        },
      })
    );
    setNotifyMeBtn(false);

    // window.scrollTo(0, 0);
    // setShow(true);
    // window.scroll({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
    // alert("We will notify you whenever the session is addes to this event");
  };

  const renderTableBody = (sessionList, isPastTab) => {
    return sessionList.map((session, index) => {
      return (
        isPastTab && session.isFuture ? "" : (!isPastTab && session.is_past) ? "" : <>
          <TableRow
            key={`session-${index}`}
            sx={{ "& > *": { borderBottom: "unset" } }}
          >
            <TableCell>
              <div className="d-flex align-items-start gap-2">
                <div
                  onClick={() => {
                    const openList = _.clone(open);
                    openList[index] = !openList[index];
                    setOpen(openList);
                  }}
                >
                  {!open[index] ? (
                    <i className="fa fa-minus"></i>
                  ) : (
                    <i className="fa fa-plus"></i>
                  )}
                </div>
                <div className="tableName">
                  {/* <div>Session {index + 1}</div> */}
                  <div>{session.session_name}</div>
                  <div className="mt-2">
                    {session.date_time.length}{" "}
                    {session.date_time.length === 1 ? "Segment" : "Segments"}
                  </div>
                </div>
              </div>
              {/* <b> {session.startDate.split(',')[0]},</b> {session.startDate.split(',')[1]} <br /> <span><b> {session.startTime} </b>hrs</span> <b> EST</b> */}
            </TableCell>
            <TableCell>{session?.provider?.provider_display_name}</TableCell>
            <TableCell>{session.host}</TableCell>
            <TableCell>{setDeliveryMode(session.delivery_mode)}</TableCell>
            <TableCell className="text-capitalize">
              {/* {session.channel_name} */}
              {session.delivery_mode === "face_to_face" ? <><strong>Address</strong><br />{session.location}</> : session.delivery_mode === "virtual_interactive" || session.delivery_mode === "virtual_broadcast" ? "Virtual" : "Live"}
            </TableCell>
            {source != "broker" ? (
              <>
                {_.toNumber(session.selling_price) !== 0 ? (
                  <TableCell className={`${session.isOffer ? 'd-flex flex-column gap-2 w-100 h-100' : ''}`}>
                    {
                      session.isOffer ?
                        <>
                          <span className="offer-tag-session">OFFER</span>
                          <div className="strike-through">
                            ${session.originalPrice}
                            CAD
                          </div>
                          <div>
                            <span className="supscript_ED"> $</span>
                            <span className="priceED">
                              {session.selling_price.split(".")[0]}
                            </span>
                            <sup>
                              <b>{session.selling_price.split(".")[1]}</b>
                            </sup>{" "}
                            CAD
                          </div>
                        </>
                        :
                        <>
                          <span className="supscript_ED"> $</span>
                          <span className="priceED">
                            {session.selling_price.split(".")[0]}
                          </span>
                          <sup>
                            <b>{session.selling_price.split(".")[1]}</b>
                          </sup>{" "}
                          CAD
                        </>
                    }
                  </TableCell>
                ) : (
                  <TableCell>
                    <b>FREE</b>
                  </TableCell>
                )}


              </>
            ) : (
              ""
            )}
            <TableCell>{renderButton(session, isPastTab)}</TableCell>
            {userRole === "manager" ? <TableCell>
              <p className="text-left_ED text-center">

                {session.product_basic_price === "" && !session.is_past &&
                  (session.show_register || session.first_segment_end) ? <button
                    type="button"
                    className={`btn btn-primary btn-primaryBook_ED cursor-pointer`}
                    onClick={() => {
                      dispatch(setCurrentView(1))
                      setShow(true)
                      setSelectedSession(source === 'broker' ? session.session_id : session.course_code)
                    }}>
                  Assign
                </button> : ""}
              </p>
            </TableCell> : ""}
          </TableRow>
          <TableRow>
            <TableCell
              colSpan={source != "broker" ? 7 : 6}
              style={{ paddingBottom: 0, paddingTop: 0, height: 0 }}
              className="bg-white br-0"
            >
              <Collapse in={!open[index]} timeout="auto" unmountOnExit>
                <Table className="clear-border" component={Paper}>
                  <TableHead>
                    <TableRow>
                      <TableCell scope="col" className="col-md-2 table-title" />
                      <TableCell scope="col" className="col-md-2 table-title">
                        Start Date & Time
                      </TableCell>
                      <TableCell scope="col" className="col-md-2 table-title">
                        End Date & Time
                      </TableCell>
                      <TableCell
                        scope="col"
                        className="col-md-2 table-title"
                      ></TableCell>
                      <TableCell
                        scope="col"
                        className="col-md-2 table-title"
                      ></TableCell>
                      {source != "broker" ? (
                        <TableCell
                          scope="col"
                          className="col-md-2 table-title"
                        ></TableCell>
                      ) : (
                        ""
                      )}
                      <TableCell
                        scope="col"
                        className="col-md-1 table-title"
                      ></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {session.date_time &&
                      session.date_time.map((date, index) => {
                        return (
                          (!isPastTab && date.is_past) ? "" : isPastTab && !date.is_past ? "" :  //&& session.is_registered
                            <TableRow key={`date-${index}`}>
                              {
                                date.segment_title ?
                                  <TableCell>{date.segment_title}</TableCell>
                                  :
                                  <TableCell>Segment {index + 1}</TableCell>
                              }
                              <TableCell>
                                {date.startD}
                                <br />
                                {/* at&nbsp; */}
                                {date?.startDateTime?.format("hh:mm A") +
                                  " " +
                                  date?.startDateTime?.format('z')}
                              </TableCell>
                              <TableCell>
                                {date.endD}
                                <br />
                                {/* at&nbsp; */}
                                {date?.endDateTime?.format("hh:mm A") +
                                  " " +
                                  date?.endDateTime.format('z')}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell>
                                {session.is_registered &&
                                  date.is_past &&
                                  date.watch_url ? (
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-primaryBook_ED cursor-pointer event-btn"
                                    onClick={() =>
                                      watchSession(session, date.watch_url)
                                    }
                                  >
                                    Watch
                                  </button>
                                ) : (
                                  ""
                                )}
                              </TableCell>
                            </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      );
    });
  };


  const renderNotifyBody = () => {
    return (
      <>
        <div>
          <div className="session-found-notify no-session-found">
            {/* <div className="img-no-session">
              <img
                src="/images/no-session-found.svg"
                alt="No session found"
              />
            </div> */}
            <p className="no-ssesion-found-text">
              Want to get notified, when more sessions will be added? Click on
              the below checkbox.
            </p>
            <div className="d-flex btnsnotify">
              <input
                type="checkbox"
                className="form-check-input cursor-pointer"
                name="notify-me"
                checked={notifyMeBtn ? true : ""}
                onClick={(e) => {
                  if (e.target.checked) {
                    // console.log("Target1", e.target.checked);
                    onNotifyMeHandler();
                  } else {
                    // console.log("Target2", e.target.checked);
                    uncheckNotifyMeHandler();
                    // console.log("Target3", e.target.checked);
                  }
                }}
              />
              &nbsp;Notify Me
              {/* <button
              className="notfime"
              disabled={notifyMeBtn}
              onClick={onNotifyMeHandler}
            >
              Notify Me
            </button>
            <button
              className="notfime"
              onClick={uncheckNotifyMeHandler}
            >
              Deselect
            </button> */}
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderEmptySessionTable = () => {
    return (
      <>
        <div>
          <div className="session-found-notify no-session-found">
            <div className="img-no-session">
              <img
                src="/images/no-session-found.svg"
                alt="No session found"
              />
            </div>
            <p className="no-ssesion-found-text">
              No sessions currently available.
            </p>
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <Loader start={isLoaded} />
      <section
        className="event_ED_BGimage"
        style={{ background: `url(${eventDetail?.bannerURL})` }}
      >
        <div className="row realtorRow">
          <div className=" col-md-6 bg-whites opacity-68 realtor_col"></div>
        </div>
        <div className="realtor_content">
          <div className="container position-relative">
            {renderAlertCard()}
            <div className="header_img_left_ED">
              {/* <h6
                dangerouslySetInnerHTML={{
                  __html: eventDetail?.event_name,
                }}
              ></h6> */}
            </div>
          </div>
        </div>
      </section>
      <section className="container ">
        {!_.isEmpty(eventDetail) ? (
          <>
            <div className="row">
              <div className="col-md-12 main_realtor mt-5">
                <h6 className="pb-3">
                  Welcome to the
                  <br />{" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: eventDetail?.event_name,
                    }}
                  ></span>
                </h6>
                <div
                  className="event-details-disc"
                  dangerouslySetInnerHTML={{
                    __html: eventDetail?.event_description,
                  }}
                ></div>
              </div>
            </div>

            <div className="Registration mt-4 ">
              <p>Registration</p>
            </div>
          </>
        ) : (
          ""
        )}
        {isSessionDataLoaded ? (
          sessionList.length > 0 || pastSessionList.length > 0 ? (
            <div className="registration">

              <div className="row my_learningpath_tab">
                <Tabs defaultActiveKey={0} className="mb-3" onSelect={(ev) => {
                  if (ev === 1) {
                    setPastClicked(true)
                  } else { setPastClicked(false) }
                }}>
                  <Tab eventKey={0} title="Upcoming Sessions">
                    <div className="agetns-table-content" >
                      <>
                        {sessionList.length > 0
                          ? <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                              <TableHead className="thead_bdy_ED thead_bdy_border">
                                <TableRow>
                                  <TableCell scope="col" className="col-md-2 table-title">
                                    Session
                                  </TableCell>
                                  <TableCell scope="col" className="col-md-2 table-title">
                                    Provider
                                  </TableCell>
                                
                                  <TableCell scope="col" className="col-md-2 table-title">
                                    Instructor
                                  </TableCell>
                                  <TableCell scope="col" className="col-md-2 table-title">
                                    Delivery Mode
                                  </TableCell>
                                  <TableCell scope="col" className="col-md-1 table-title">
                                    Location
                                  </TableCell>
                                  {source != "broker" ? (
                                    <TableCell scope="col" className="col-md-2 table-title">
                                      Pricing
                                    </TableCell>
                                  ) : (
                                    ""
                                  )}
                                  <TableCell scope="col" className="col-md-1 table-title text-center">
                                    Action
                                  </TableCell>
                                  {userRole === "manager" ? <TableCell scope="col" className="col-md-1 table-title text-center last-btn-col">
                                    Assign
                                  </TableCell> : ''}
                                </TableRow>
                              </TableHead>
                              <TableBody className="tble_bdy">
                                {renderTableBody(sessionList, false)}
                              </TableBody>
                            </Table>
                          </TableContainer> :
                          renderEmptySessionTable()}
                      </>
                      {source === 'ecom' ? renderNotifyBody() : ''}
                    </div>
                  </Tab>
                  <Tab eventKey={1} title="Past Sessions">
                    <div className="teams-table-content" >
                      <>
                        {pastSessionList.length > 0 ?
                          <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                              <TableHead className="thead_bdy_ED thead_bdy_border">
                                <TableRow>
                                  <TableCell scope="col" className="col-md-2 table-title">
                                    Session
                                  </TableCell>
                                  <TableCell scope="col" className="col-md-2 table-title">
                                    Provider
                                  </TableCell>
                                 
                                  <TableCell scope="col" className="col-md-2 table-title">
                                    Instructor
                                  </TableCell>
                                  <TableCell scope="col" className="col-md-2 table-title">
                                    Delivery Mode
                                  </TableCell>
                                  <TableCell scope="col" className="col-md-1 table-title">
                                    Location
                                  </TableCell>
                                  {source != "broker" ? (
                                    <TableCell scope="col" className="col-md-2 table-title">
                                      Pricing
                                    </TableCell>
                                  ) : (
                                    ""
                                  )}
                                  <TableCell scope="col" className="col-md-1 table-title text-center">
                                    Action
                                  </TableCell>
                                  {userRole === "manager" ? <TableCell scope="col" className="col-md-1 table-title text-center last-btn-col">
                                    Assign
                                  </TableCell> : ''}
                                </TableRow>
                              </TableHead>
                              <TableBody className="tble_bdy">
                                {renderTableBody(pastSessionList, true)}
                              </TableBody>
                            </Table>
                          </TableContainer> :
                          renderEmptySessionTable()}
                      </>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          ) : (
            <>
              <div>
                {source === "ecom" ? (
                  <div className="no-session-found">
                    <div className="img-no-session">
                      <img
                        src="/images/no-session-found.svg"
                        alt="No session found"
                      />
                    </div>
                    <p className="no-ssesion-found-text">
                      No sessions currently available. Click on the below
                      checkbox to get notified, when more session are added.
                    </p>

                    <div className="d-flex btnsnotify">
                      <input
                        type="checkbox"
                        className="form-check-input cursor-pointer"
                        name="notify-me"
                        checked={notifyMeBtn ? true : ""}
                        onClick={(e) => {
                          if (e.target.checked) {
                            onNotifyMeHandler();
                          } else {
                            uncheckNotifyMeHandler();
                          }
                        }}
                      />
                      &nbsp;Notify Me
                      {/* <button
                      className="notfime"
                      disabled={notifyMeBtn}
                      onClick={onNotifyMeHandler}
                    >
                      Notify Me
                    </button>
                    <button
                      className="notfime">
                      Deselect
                    </button> */}
                    </div>
                  </div>
                ) : (
                  renderEmptySessionTable()
                )}
              </div>

              {show && (
                <div className="alert-card d-flex justify-content-center event-alter-sucess">
                  <div className="shop-cart order-details event-notify-sucess">
                    <div className="shop-info justify-content-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                      >
                        <g
                          id="Group_5699"
                          data-name="Group 5699"
                          transform="translate(0.498 0.498)"
                        >
                          <circle
                            id="Ellipse_222"
                            data-name="Ellipse 222"
                            cx="9"
                            cy="9"
                            r="9"
                            transform="translate(-0.498 -0.498)"
                            fill="#A9C23C"
                          />
                          <path
                            id="Icon_material-done"
                            data-name="Icon material-done"
                            d="M9.712,16.558,7.79,14.88l-.9.9L9.712,18.35l6.425-6.657-.9-.9Z"
                            transform="translate(-3.013 -6.071)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="2"
                          />
                        </g>
                      </svg>
                      <p className="m-0">
                        We will notify you whenever a session is added to this
                        event.
                      </p>
                    </div>
                    <div className="view-cart-icon">
                      {/* <span className="cursor-pointer">View Cart</span> */}
                      <i
                        className="fa fa-times cursor-pointer"
                        aria-hidden="true"
                        onClick={() => setShow(false)}
                      ></i>
                    </div>
                  </div>

                  {/* <button
              className={"btn btn-primary btn-primaryBook_ED cursor-pointer"}
                style={{marginLeft: "40%", width: "230px" }}
                disabled={notifyMeBtn}
                onClick={onNotifyMeHandler}
              >
                Notify Me
              </button> */}
                </div>
              )}
            </>
          )
        ) : (
          <div className="d-flex w-100 gap-2 align-items-center justify-content-start">
            Loading sessions
            <div className="spinner">
              <div className="bounce1"></div>
              <div className="bounce2"></div>
              <div className="bounce3"></div>
            </div>
          </div>
        )}
      </section>
      <AssignCourseModal
        show={show}
        parentName={'Event Session'}
        parentId={selectedSession}
        setShow={setShow}
        origin={source === "xsel" || source === "ecom" ? "xsel" : "broker"}
        isMobile={false}
      />
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isConfirm={true}
        confirmId={sessionDataForModal}
        confirmAction={cancelSession}
      />
    </div>

  );
};

export default EventDetailSection;
